<template>
  <div class="address-manage-box"
       v-loading="loading">
    <div class="unit-wrap">
      <div class="unit"
           v-for="vm in renderList"
           :key="vm.id"
           @click="handleSelect(vm, $event)">
        <div class="unit-mask"
             :class="{'show':vm.id === references.recipientsId}">
          <div class="triangle"></div>
          <i class="gt-icon-check"
             @click="updateDialog(vm)"></i>
        </div>
        <div class="unit-content">
          <div class="unit-head">
            <strong>{{ vm.name }}</strong>
            <em>收</em>
            <i class="iconfont icontianxie"></i>
            <span class="default-address fr"
                  v-if="vm.isDefault === 1">默认地址</span>
          </div>
          <div class="unit-body">
            <p :title="generateAddress(vm.province, vm.city, vm.area, vm.street)">{{ generateAddress(vm.province, vm.city, vm.area, vm.street) }}</p>
          </div>
          <div class="unit-footer">
            <p>{{ vm.phone }}</p>
          </div>
        </div>
        <gt-radio v-model="references.recipientsId"
                  :label="vm.id"
                  name="addressOption"
                  v-validate="'required'"
                  v-show="false"></gt-radio>
      </div>
      <div class="unit add-unit"
           v-if="renderList.length < 4"
           @click="openDialog">
        <i class="iconfont iconchuangjian"></i>
        <p>添加新的收件地址</p>
      </div>
    </div>
    <address-dialog ref="dialog"
                    @operationSuccess="_QueryList"></address-dialog>
  </div>
</template>

<script>
import { queryList } from '@/api/address/index'
import AddressDialog from '@/views/main/personal/address/address_dialog'
export default {
  name: 'AddressManageBox',
  components: {
    AddressDialog
  },
  inject: ['sourceData'],
  data () {
    let references = this.sourceData
    return {
      renderList: [],
      maxLength: 4,
      references,
      loading: true
    }
  },
  computed: {
    geo () {
      return this.$store.getters.getGeo
    }
  },
  methods: {
    handleSelect (vm, ev) {
      if (ev.target.className === 'iconfont icontianxie') {
        this.updateDialog(vm)
        return false
      }
      this.references.recipientsId = vm.id
    },
    openDialog () {
      if (this.renderList.length < this.maxLength) this.$refs.dialog.openDialog()
    },
    updateDialog (vm) {
      this.$refs.dialog.updateDialog(vm)
    },
    _QueryList (params = {}) {
      this.loading = true
      queryList(params).then(
        res => {
          this.loading = false
          const resData = res.data.data
          this.renderList = resData.consignees
          this.setDefault(resData.consignees)
        },
        errRes => {
          this.loading = false
        }
      )
    },
    setDefault (consignees) {
      /* 用户可能删除了地址，如果删除了，导致找不到，直接用默认地址好了 */
      let targetId
      let isAlive = false
      consignees.forEach(el => {
        if (this.references.recipientsId === el.id) isAlive = true
        if (el.isDefault === 1) targetId = el.id
      })
      if (this.$route.query.type === 'update') {
        if (!isAlive) { // 用户删除了该地址，直接用默认的
          this.references.recipientsId = targetId
          return false
        }
      }
      this.references.recipientsId = targetId
    },
    validate () {
      if (!this.references.recipientsId) this.$message.warning('请选择材料接收地址!')
      return this.$validator.validateAll()
    },
    generateAddress (province, city, area, street) {
      let result = ''
      this.geo.forEach(elem => {
        if (elem.code === province) {
          result += elem.name
          elem.children.forEach(ele => {
            if (ele.code === city) {
              result += ele.name
              ele.children.forEach(el => {
                if (el.code === area) {
                  result += el.name
                }
              })
            }
          })
        }
      })
      result += street
      return result
    }
  },
  created () {
    this._QueryList()
  }
}
</script>

<style lang='less' scoped>
.address-manage-box {
  .unit-wrap {
    display: flex;
    // align-items: center;
    flex-wrap: wrap;

    align-items: flex-start;
    align-content: flex-start;
    justify-content: space-between;
    .unit {
      position: relative;
      margin-bottom: 18px;
      width: 315px;
      height: 137px;
      border: 1px solid #dddddd;
      cursor: pointer;
      &:hover {
        .unit-mask {
          display: block;
        }
      }
      .unit-content {
        position: relative;
        z-index: 1;
        padding: 20px;
        .unit-head {
          margin-bottom: 12px;
          strong {
            font-size: 14px;
            color: #333333;
          }
          em {
            margin: 0 10px;
            font-size: 14px;
            font-weight: bold;
            font-style: normal;
            color: #333333;
          }
          .default-address {
            color: @base-viColor;
          }
        }
        .unit-body {
          margin-bottom: 12px;
          p {
            position: relative;
            height: 40px;
            font-size: 14px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .unit-footer {
          p {
            font-size: 14px;
            color: #666666;
          }
        }
      }
      .unit-mask {
        display: none;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        border: 2px solid @base-viColor;
        background: #fafcff;
        .gt-icon-check {
          position: absolute;
          right: 2px;
          bottom: 2px;
          color: #ffffff;
          font-size: 18px;
          font-weight: bold;
        }
        .triangle {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 0;
          height: 0;
          border-bottom: 36px solid @base-viColor;
          border-left: 36px solid transparent;
        }
      }
    }
    .show {
      display: block !important;
    }
    .add-unit {
      padding: 10px 106px;
      text-align: center;
      // cursor: pointer;
      .iconfont {
        font-size: 60px;
        font-weight: normal;
        color: #dddddd;
      }
      p {
        color: #666666;
      }
    }
  }
}
</style>
